<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="search">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item  label="">
              <el-input  v-model="formInline.realname" placeholder="请输入学员姓名" ></el-input>
            </el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="warning" @click="onReset">重置</el-button>
            <el-button type="primary" @click="batchDelete">批量删除</el-button>
            <!-- <el-button type="primary" @click="importStudent">导入学员</el-button> -->
            <!-- <el-button type="warning" @click="downloadImportStudent">下载导入学员模版</el-button> -->
            <el-button type="primary" @click="distributionClass">分配班级</el-button>
            <el-button type="primary" class="addBtn" @click="addStudent">添加</el-button>
          </el-form>
        </div>
        <div class="table">
          <el-table
            ref="multipleTable"
            border
            tooltip-effect="dark"
            @select="seclectRow"
            @selection-change="handleSelectionChange"
            :data="tableData"
            min-height="350px"
            :header-cell-style="{background:'#f5f7fa',color:'#606266'}"
            style="width: 100%">
             <el-table-column
                type="selection"
                fixed
                width="30">
            </el-table-column>
            <el-table-column
              label="学员姓名"
             >
              <template slot-scope="scope">{{ scope.row.realname }}</template>
            </el-table-column>
            <el-table-column
              label="是否分班"
              width="80"
             >
              <template slot-scope="scope" >
                <span v-if="scope.row.group_id != 0" class="activation">已分班</span>
                <span v-else class="noactivation">未分班</span>
              </template>
            </el-table-column>
            <el-table-column
              label="手机号"
              >
              <template slot-scope="scope"> {{scope.row.phone}}</template> 
            </el-table-column>
            <el-table-column
              label="身份证号"
             >
              <template slot-scope="scope">{{scope.row.idcard}}</template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              width="130"
             >
              <template slot-scope="scope">{{ scope.row.create_time }}</template>
            </el-table-column>
            <el-table-column
              label="入学登记表"
             >
              <template slot-scope="scope">
                <!--  -->
                <el-button
                  class="nopass"
                  v-if="scope.row.record_status === 0"
                  size="mini"
                  @click="examineForm(scope.$index, scope.row)">未审核</el-button>
                <el-button
                  class="onpass"
                  v-else-if="scope.row.record_status === 10"
                  size="mini"
                  @click="examineForm(scope.$index, scope.row)">审核通过</el-button>
                <el-button
                  class="nopass"
                  v-else
                  size="mini"
                  @click="examineForm(scope.$index, scope.row)">审核失败</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="实名认证"
              width="80"
             >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.renzheng_status === 0" class="nopass"
                  size="mini"
                  @click="authentication(scope.$index, scope.row)">未认证</el-button>
                <el-button
                  v-else-if="scope.row.renzheng_status === 5" class="onpass"
                  size="mini"
                  @click="authentication(scope.$index, scope.row)">审核中</el-button>
                <el-button
                  v-else-if="scope.row.renzheng_status === 10" class="nopass"
                  size="mini"
                  @click="authentication(scope.$index, scope.row)">认证失败</el-button>
                <el-button
                  v-else-if="scope.row.renzheng_status === 15" class="pass"
                  size="mini"
                  @click="authentication(scope.$index, scope.row)">认证成功</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="是否激活"
              width="80"
             >
              <template slot-scope="scope">
                <span v-if="scope.row.active_status === 1" class="activation">已激活</span> 
                <span v-else class="noactivation">未激活</span> 
              </template>
            </el-table-column>
            <el-table-column
              width='115'
              fixed="right"
              label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary" plain
                  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table_pagination">
          <el-pagination
            background
            @prev-click="prevClick"
            @next-click="nextClick"
            @current-change="currentClick"
            layout="prev, pager, next"
            :total="total"
            :page-size="page_size">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialog"
      :close-on-click-modal="false"
      width="30%"
      center>
      <span>您是否确定删除所选学员？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <distributionF v-if="showDistribution" :id="id" :showDistribution="showDistribution" @distributionConfirm="distributionConfirm" @distributionConcel="distributionConcel"></distributionF>
    <importStudent v-if="showimport" :type="type" :id="id" :showimport="showimport" @importConfirm="importConfirm" @importConcel="importConcel" @importFile="importFile"></importStudent>
    <authentication :studentId="studentId" v-if="showRealname" :showRealname="showRealname" :realnameList="realnameList" @realnameConfirm="realnameConfirm" @realnameConcel="realnameConcel"></authentication>
  </div>
</template>
<script>

import { total,page, page_size} from '../../../config'
import distributionF from './distributionClass'
import importStudent from './importStudent'
import authentication from './authentication'
// @ is an alias to /src
export default {
  name: 'periodStudent',
  components: {
    distributionF,
    importStudent,
    authentication
  },
  data(){
    return {
      tableData: [],
      formInline: {
        realname:'',//
      },
      centerDialog: false,
      total,
      page,
      page_size,
      deleteList:[],
      distribution:[],
      distributionList:[],
      showDistribution :false,
      id:'',
      showimport:false,
      file:'',
      studentId:'',
      showRealname:false,
      realnameList:{},
      type:'period',
      url:window.location.origin 
    }
  },
  created(){
    this.id = this.$route.params && this.$route.params.id
    this.url = this.url + window.location.pathname + 'xls/studentTemplate.xls'
  },
  mounted(){
    this.onSubmit()
  },
  methods:{
    getinfor(params){
      this.$api.user.noRegisterList(params)
        .then(res=>{
          if(res.code === 0){
            this.tableData = res.result.result
            this.total = res.result.total
          }else if(res.code === 1010){
            this.tableData = []
            this.total = 0
          }
        }) 
    },
    handleEdit(index,row) {
      this.$router.push({
        path:'/period/editPeriodStudent/' + row.id,
        query:{
          period:this.id
        }
      })
    },
    handleDelete(index,row) {
      this.deleteList = []
      this.deleteList.push(row.id)
      this.centerDialog = true
    },
    handleSelectionChange(value){
      let arr = value
      this.deleteList = []
      for(let i = 0;i < arr.length ; i++){
        this.deleteList.push(arr[i].id)
      }
    },
    seclectRow(selsect,row){
      let arr = selsect
      this.distributionList = []
      if(row.group_id === 0){
        for(let i = 0;i < arr.length ; i++){
          this.distributionList.push(arr[i].id)
        }
      }else{
        console.log('此学员已分配！');
      }
    },
    onSubmit() {
      let params = {
        realname:this.formInline.realname,
        period_id:this.id,
        page:this.page,
        page_size:this.page_size
      }
        this.getinfor(params)
    },
    onReset(){
      if(this.formInline.realname){
        this.formInline.realname = ''
        this.onSubmit()
      }
    },
    addStudent(){
      this.$router.push({
        path:'/period/addPeriodStudent/' + this.id,
      })
    },
    batchDelete(){
      if(this.deleteList.length > 0 && this.deleteList){
        this.centerDialog = true
      }else{
        this.$message.error('请选择要删除的学生')
      }
    },
    
    downloadImportStudent(){
      let a = document.createElement('a');
      a.href = this.url 
      a.download = '导入模版.xls'
      a.click()
    },
    // 分配班级
    distributionClass(){
      if(this.distributionList && this.distributionList.length> 0){
        this.showDistribution = true
      }else{
        this.$message.error('请选择要分配的学生')
      }
    },
    distributionConfirm(data){
      let params = {
        ids:JSON.stringify(this.distributionList),
        group_id:data
      }
      if(data){
        this.$api.user.distributionClass(params)
        .then(res=>{
          if(res.code === 0){
            this.$message.success('分配成功')
            this.onSubmit()
            this.showDistribution = false
          }
        })
      }else{
        this.$message.error('请选择班级')
      }
    },
    distributionConcel(){
      this.showDistribution = false
    },
    // 导入学员
    importStudent(){
      this.showimport = true
    },
    importFile(data){
      this.file = data
    },
    importConfirm(data){
      event.preventDefault();
      let formdata = new FormData();
      formdata.append('period_id',Number(this.id));
      formdata.append('group_id',data.group_id);
      formdata.append('file',this.file);
      if(this.file){
        this.instance.post('manager/student/import',formdata)
        .then(res=>{
          if(res.data.code === 0){
            this.$message.success('导入成功')
            this.showimport = false
             let params = {
              period_id:this.id,
              realname:this.formInline.realname,
              page:this.page,
              page_size:this.page_size
            }
            this.getinfor(params)
          }else{
            let str = res.data.message
            this.showimport = false
            this.$message.error(str)
          }
        })
      }else{
        this.$message.error('请上传文件')
      }
    },
    importConcel(){
      this.showimport = false
    },
    
    // 认证
    authentication(index,row){
      this.showRealname = true
      this.realnameList = row
    },
    realnameConcel(){
      this.showRealname = false
    },
    realnameConfirm(data){
      let params ={
        student_id:this.realnameList.id,
        status:data.status,
        reson:data.reson
      }
      if(data.status){
        this.$api.user.certificateStudent(params)
        .then(res=>{
          if(res.code === 0){
            this.$message.success('已审核')
            this.showRealname = false
          }
        })
      }else{
        this.$message.error('请选择审核状态')
      }
    },

    // 入学登记表
    examineForm(index,row){
      this.$router.push({
        path:'/period/entranceForm/' + row.id,
        query:{
          status:row.record_status,
          // id:this.id
        }
      })
    },
    confirm(){
      let id= JSON.stringify(this.deleteList)
      let params = {
        student_id:id
      }
      this.$api.user.deleteStudent(params)
        .then(res=>{
          if(res.code === 0){
            this.centerDialog = false
            this.onSubmit()
            this.$message.success('删除成功！');
          }
        }) 
    },
    cancel(){
      this.centerDialog = false
    },
    currentClick(val){
      let params = {
          period_id:this.id,
          realname:this.formInline.realname,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
    nextClick(val){
      let params = {
          period_id:this.id,
          realname:this.formInline.realname,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
    prevClick(val){
      let params = {
          period_id:this.id,
          realname:this.formInline.realname,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
  },
    
}
</script>
<style lang="scss" scoped>
  @import '../../../assets/scss/content.scss';
</style>